// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantsTableRow-moduleRentalPortalApplicantsTableRow__Dj90G TableComponent-modulerow__xPAo4";
export { _1 as "RentalPortalApplicantsTableRow" }
